import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=fc46f940&scoped=true&"
import script from "./QuestionComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=fc46f940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc46f940",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VAlert,VBtn,VCard,VIcon,VOverlay,VRadio,VRadioGroup})
